import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';
import type { ClientPacket } from '../models/ClientPacket';
import type { ClientPacketResponse } from '../models/ClientPacketResponse';
import { parseISO } from 'date-fns';

const GET_CLIENT_PACKET = gql`
  query clientPacket($allAgreement: Boolean) {
    agreement(allAgreement: $allAgreement) {
      signingUrl
      reportUrl
      patientSfId
      signed
      sentAt
      signedAt
      updatedDate
      patientFirstName
      patientLastName
      expirationDate
    }
  }
`;

const clientPacketFromJson = (json: ClientPacketResponse): ClientPacket => {
  return {
    type: 'CLIENT_PACKET',
    signed: json.signed,
    patientFirstName: json.patientFirstName,
    patientLastName: json.patientFirstName,
    patientSfId: json.patientSfId,
    surveyLink: json.signingUrl,
    expirationDate: parseISO(json.expirationDate),
  };
};

export const clientPackets = async (
  allAgreement = true,
): Promise<ClientPacket[]> => {
  try {
    const response = await graphql.query<{
      agreement: ClientPacketResponse[];
    }>({
      query: GET_CLIENT_PACKET,
      variables: { allAgreement },
      fetchPolicy: 'no-cache',
    });

    return response.data?.agreement
      .filter((survey: ClientPacketResponse) => Boolean(survey.signingUrl))
      .map((survey: ClientPacketResponse) => clientPacketFromJson(survey));
  } catch (e) {
    console.debug('Failed to get client intake packet');
    return [];
  }
};
